import { Producers } from '../../constants/producers';
import {
  CheckIfGroupIsFinishedRule,
  CheckIfTheTicketGroupCanBeSoldRule,
  CheckSalesOpeningRule,
  ConcatStatusSessionInDateTicketRule,
  IdentifyTicketWithCarouselIdRule,
  SortTicketsByDateAndClosingAndStockRule,
  SortTicketsByOrderRule
} from '../implementations';
import { BahiaFutebolRuleSetStrategy, BotafogoFutebolRuleSetStrategy } from '../producers';
import { Rule } from '../Rule';
import { RuleContext } from '../RuleContext';
import { RuleSetStrategy } from './RuleSetStrategy';

export class FutebolRuleSetStrategy implements RuleSetStrategy {
  private readonly producerStrategies: Record<string, RuleSetStrategy>;

  constructor() {
    this.producerStrategies = {
      Bahia : new BahiaFutebolRuleSetStrategy(),
      Botafogo : new BotafogoFutebolRuleSetStrategy(),
    };
  }

  getRules(context: RuleContext): Rule[] {
    const producerId = context.event.producerId;

    for (const [key, ids] of Object.entries(Producers)) {
      if (ids.includes(producerId)) {
        return this.producerStrategies[key].getRules(context);
      }
    }

    return [
      new CheckSalesOpeningRule(),
      new CheckIfGroupIsFinishedRule(),
      new IdentifyTicketWithCarouselIdRule(),
      new SortTicketsByDateAndClosingAndStockRule(),
      new CheckIfTheTicketGroupCanBeSoldRule(),
      new ConcatStatusSessionInDateTicketRule(),
      new SortTicketsByOrderRule(),
    ];
  }
}
